import { history } from "../appRedux/store/index";
const Futch = async (url, opts = {}, navigation) => {
  try {
    //alert('fetch started url=' + url + '\n opt=' + JSON.stringify(opts));

    // opts.headers["Access-Control-Allow-Headers"] =
    //   "X-Requested-With,content-type";
    opts.headers["Access-Control-Allow-Origin"] = "*";
    // opts.headers["Access-Control-Allow-Methods"] =
    //   "GET, POST, OPTIONS, PUT, PATCH, DELETE";
    // opts.headers["Access-Control-Allow-Credentials"] = true;
    // opts.headers["Origin"] = "localhost:3000";

    //opts["mode"] = "no-cors";
    // console.log("token", JSON.stringify(opts));
    // console.log("Url Calling=", url);
    // console.log("Option=", opts);

    const Response = await fetch(url, opts);
    //console.warn(Response);
    const ResponseText = await Response.text();
    const IsJson = await IsJsonString(ResponseText);
    if (Response.status === 200) {
      if (IsJson) {
        const ResponseJson = await JSON.parse(ResponseText);
        return {
          id: ResponseJson.id,
          message: ResponseJson.message,
          traceMessage: ResponseJson.traceMessage,
        };
      } else {
        return {
          id: 999,
          message: ResponseText,
          traceMessage: ResponseText,
        };
      }
    }

    if (Response.status === 401) {
      history.push("/logout");
      return {
        id: -Response.status,
        message: "نشت شما منقضی شده است",
        traceMessage: null,
      };
    }
    if (Response.status === 403) {
      history.push("/logout");
      return {
        id: -Response.status,
        message: "خطای دسترسی",
        traceMessage: null,
      };
    }

    if (IsJson) {
      const ResponseJson = await JSON.parse(ResponseText);

      return {
        id: -Response.status,
        message: ResponseJson.message,
        traceMessage: null,
      };
    } else {
      return {
        id: -Response.status,
        message: "خطای " + Response.status,
        traceMessage: null,
      };
    }
  } catch (error) {
    // Alert.alert('کاریر محترم', 'عدم ارتباط با سرور ', [{text: 'باشه'}], {
    //   cancelable: false,
    // });
    //alert(error);
    return {
      id: -2,
      message: "عدم ارتباط با سرور",
      traceMessage: error,
    };
  }
};
async function IsJsonString(str) {
  try {
    await JSON.parse(str);
  } catch (e) {
    //console.warn('false');
    return false;
  }
  //console.warn('true');
  return true;
}

export default Futch;
